// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationTouchResponse {
    static getAttributeTypeMap() {
        return AuthenticationTouchResponse.attributeTypeMap;
    }
}
AuthenticationTouchResponse.discriminator = undefined;
AuthenticationTouchResponse.additionalProperties = false;
AuthenticationTouchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "AuthenticateStatus"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "IsHcpIntakeAllowedRequestModelGender"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "AuthenticationTouchResponseData"
    },
];
//# sourceMappingURL=authenticationTouchResponse.js.map